export default "__VITE_ASSET__wv9i$RwW__"